<template>
	<div class="display-flex flex-row flex-align-center">
		<div class="pr-2">
			<AppIcon name="feature-addon" />
		</div>
		<h1 class="med">
			<div class="flex-centerize">
				New Add-on in
				<template v-if="app">
					<AppIcon :name="appIcon" width="20" height="24" class="mx-2" />
					{{ appName }}
				</template>
			</div>
		</h1>
	</div>
</template>

<script>
export default {
	name: 'AddOnHeader',
	props: { app: { type: Object } },
	computed: {
		appName() {
			return this.app.service_name;
		},
		appIcon() {
			return this.app.service_slug;
		},
	},
};
</script>

<style lang="scss" scoped></style>
